import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import styles from "./AppHeader.module.css";
import GlobalSearch from "../globalSearch/GlobalSearch";

function AppHeader({ menuOpen, onMenuToggle, menuId }) {
  return (
    <header className={styles.header}>
      <img src="/logopreta.png" alt="weDress" className={styles.logo} />
      <GlobalSearch />
      <button type="button" onClick={onMenuToggle} aria-label="Abrir menu" aria-expanded={menuOpen} aria-controls={menuId}>
        <FontAwesomeIcon icon={faBars} aria-hidden="true" />
      </button>
    </header>
  );
}

export default AppHeader;
